<template>
<!-- 更换型号 -->
  <div>
    <el-dialog
      :title="$t('pages.equipment.text166')"
      :visible.sync="replaceVisible"
      width="650px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <!-- 批次更换 -->
          <el-tab-pane :label="$t('pages.equipment.text167')" name="batch">
            <el-form
              :model="params"
              ref="ruleForm"
              label-width="auto"
              class="demo-ruleForm"
              :rules="rules"
            >
              <el-form-item
                :label="$t('pages.equipment.text20')"
                prop="batchId"
              >
                <el-select
                  v-model="params.batchId"
                  :placeholder="$t('public.text5')"
                  @change="selectBatch"
                >
                  <el-option
                    v-for="item in findAllBatchList"
                    :key="item.id"
                    :label="item.batchId"
                    :value="item.batchId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                :label="$t('pages.equipment.text168')"
                prop="bikeTypeId"
                v-if="params.batchId"
              >
                <el-select
                  v-model="params.bikeTypeId"
                  :placeholder="$t('public.text5')"
                >
                  <el-option
                    v-for="item in findAllBikeTypeList"
                    :key="item.id"
                    :label="item.bikeTypeName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                :label="$t('pages.equipment.text169')"
                prop="remark"
              >
                <el-input
                  type="textarea"
                  v-model="params.remark"
                  :rows="4"
                ></el-input>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <!-- 批量更换 -->
          <el-tab-pane :label="$t('pages.equipment.text170')" name="lotSize">
            <el-form
              ref="form"
              :model="from"
              label-width="auto"
              class="demo-ruleForm"
              :rules="fromRules"
            >
              <el-form-item :label="$t('button.downloadTemplate')">
                <DiluButton
                  type="export"
                  @click="importMasterplate"
                  :title="$t('button.downloadTemplate')"
                ></DiluButton>
                <span>{{ $t("pages.equipment.text61") }}</span>
              </el-form-item>
              <el-form-item :label="$t('pages.equipment.text63')">
                <DiluButton
                  type="import"
                  @click="equipmentImport"
                  :title="$t('pages.equipment.text63')"
                  :fileList="fileList"
                ></DiluButton>
                <span>{{ $t("pages.equipment.text62") }}</span>
              </el-form-item>
              <el-form-item
                :label="$t('pages.equipment.text168')"
                prop="bikeTypeId"
              >
                <el-select
                  v-model="from.bikeTypeId"
                  clearable
                  :placeholder="$t('public.text5')"
                >
                  <el-option
                    v-for="(item, index) in allfindAllBikeTypeList"
                    :key="index"
                    :label="item.bikeTypeName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                :label="$t('pages.equipment.text169')"
                prop="remark"
              >
                <el-input
                  type="textarea"
                  v-model="from.remark"
                  :rows="4"
                ></el-input>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t("button.cancel") }}</el-button>
        <el-button type="primary" :loading="loading" @click="submit">{{
          $t("button.determine")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
import DiluButton from "../../../../components/pubilc/dilu-button.vue";
export default {
  data() {
    return {
      loading: false,
      activeName: "batch",
      params: {
        batchId: "", //批次号
        bikeTypeId: "", //新车辆型号
        remark: "", //更换原因
      },
      findAllBikeTypeList: [], //车辆型号
      allfindAllBikeTypeList: [],
      from: {
        bikeTypeId: "",
        remark: "",
        url: "",
      },
      fileList: [],
      fromRules: {
        bikeTypeId: {
          required: true,
          message: this.$t("pages.equipment.text171"),
          trigger: "blur",
        },
        remark: [
          {
            required: true,
            message: this.$t("pages.equipment.text172"),
            trigger: "blur",
          },
          {
            max: 50,
            message: this.$t("pages.equipment.text173"),
            trigger: "blur",
          },
        ],
      },
      rules: {
        batchId: {
          required: true,
          message: this.$t("pages.equipment.text174"),
          trigger: "blur",
        },
        bikeTypeId: {
          required: true,
          message: this.$t("pages.equipment.text171"),
          trigger: "blur",
        },
        remark: [
          {
            required: true,
            message: this.$t("pages.equipment.text172"),
            trigger: "blur",
          },
          {
            max: 50,
            message: this.$t("pages.equipment.text173"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    DiluButton,
  },
  mounted() {
    this.allfindAllBikeTypeName();
  },
  props: ["replaceVisible", "findAllBatchList"],
  methods: {
    selectBatch(e) {
      this.params.bikeTypeId = "";
      this.findAllBikeTypeName(e);
    },
    //车辆列表-根据批次号更新-新车辆型号下拉框
    findAllBikeTypeName(e) {
      this.request.findAllBikeTypeName("?batchId=" + e).then((res) => {
        this.findAllBikeTypeList = res.data;
      });
    },
    //车辆列表-获取全部新车辆型号
    allfindAllBikeTypeName() {
      this.request.findAllBikeTypeName().then((res) => {
        this.allfindAllBikeTypeList = res.data;
      });
    },
    handleClose() {
      this.params = {
        batchId: "", //批次号
        bikeTypeId: "", //新车辆型号
        remark: "", //更换原因
      };
      this.from = {
        bikeTypeId: "",
        remark: "",
        url: "",
      };
      this.fileList = [];
      this.activeName = "batch";
      this.$refs["ruleForm"].resetFields();
      this.$emit("closeReplace");
    },
    importMasterplate() {
      this.request.importMasterplate().then();
    },
    equipmentImport(e) {
      this.from.url = e;
    },
    handleClick() {
      this.from = {
        bikeTypeId: "",
        remark: "",
        url: "",
      };
      this.params = {
        batchId: "", //批次号
        bikeTypeId: "", //新车辆型号
        remark: "", //更换原因
      };
    },
    submit() {
      let that = this;
      if (this.activeName == "batch") {
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            this.loading = true;
            this.request
              .equipmentListUpdateByBatchId(this.params)
              .then(() => {
                this.$message.success(this.$t("pages.equipment.text175"));
                this.$emit("equipmentList");
                this.handleClose();
                this.loading = false;
              });
          }
        });
      } else {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            if (!this.from.url) {
              return this.$message.error(this.$t("pages.equipment.text63"));
            }
            this.loading = true;
            this.request
              .equipmentListUpdateByBikeCode(this.from)
              .then((res) => {
                let str = `${that.$t("pages.equipment.text163")}${
                  res.data.successSize
                } ${that.$t("pages.equipment.text164")}，${that.$t(
                  "pages.equipment.text165"
                )}${res.data.failSize} ${that.$t("pages.equipment.text164")}`;
                this.$message.success(str);
                this.$emit("equipmentList");
                this.handleClose();
                this.loading = false;
              });
          }
        });
      }
    },
  },
};
</script>


<style scoped>
.demo-ruleForm {
  margin-top: 20px;
}
</style>